import React from "react";
import { Tile, fmtDate } from "./primitives";

export default function SponsorsPanel({ sponsors }) {
  return (
    <Tile title={`Homepage sponsors (${sponsors.length}/3)`} testid="tile-sponsors">
      {sponsors.length === 0 ? (
        <div className="text-xs text-[#5C6B62]">
          No sponsors yet. Slots sell at $199/mo — buyers checkout via /pricing.
        </div>
      ) : (
        <div className="space-y-2">
          {sponsors.map((s) => (
            <div
              key={s.website_url + s.expires_at}
              className="text-xs border-b border-[#F0EFEA] pb-2 last:border-0 flex items-start gap-3"
            >
              {s.logo_url && (
                <img src={s.logo_url} alt={s.display_name} className="h-8 w-auto object-contain" />
              )}
              <div className="flex-1 min-w-0">
                <div className="font-medium text-[#1C2B23]">{s.display_name}</div>
                <div className="text-[#5C6B62]">
                  {s.click_count ?? 0} clicks · exp {fmtDate(s.expires_at)}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </Tile>
  );
}
